// DebugItemIn2d.tsx
import React from "react";
import { Box } from "@mantine/core";
import { selectDebugFootprintPolygons } from "./three3Selectors";
import { IPixPolygon } from "@multiconsult-group/multiplacer-ui";
import { DeckBimViewer } from "@multiconsult-group/multiplacer-ui";
import { useAppSelector } from "../../app/hooks";

/**
 * Viser debug-geometri i 2D ved hjelp av PixBimViewer.
 */
export const DebugItemIn2d: React.FC = () => {
  const footprintItems = useAppSelector(selectDebugFootprintPolygons);

  // Konverterer fra vÃ¥rt TPolygon â†’ IPixPolygon som PixBimViewer forventer
  const polygons: IPixPolygon[] = footprintItems.map((item) => ({
    id: `${item.globalId}-${item.geometryExpressId}`,
    points: item.polygon, // [[x,y], ...] fra computeFootprintPolygon
    fillColor: "#4dabf7",
    strokeColor: "#1c7ed6",
    strokeWidth: "2",
    text: { text: "" } as any, // TODO: Tilpass til faktisk IPixItemText-type
    tooltip: `ExpressId: ${item.expressId}`,
    isMoveable: false,
    isDragSelectable: false,
    rightClickMenu: undefined,
    opacity: 0.8,
  }));

  return (
    <Box w="100%" h="100%">
      <DeckBimViewer
        flip2dCoordinate={true}
        polygons={polygons}
        paths={[]}
        circles={[]}
        angle={0}
        action="normal"
      />
    </Box>
  );
};
